import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import changepass2 from '../../Assets/Images/changepass2.png';
import PasswordChecklist from "react-password-checklist";
import './SetResetPassword.css'; 
import OtpInputModal from '../Company/OtpInputModal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RESET_PASSWORDT_FIN,RESET_PASSWORDT_OTT } from "../../Config/AppConfiguration";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const SetResetPassword = () => {
  const [repeatPassword, setRepeatPassword] = useState('');
  const [password, setPassword] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [OtpModalOpen, setOtpModalOpen] = useState(false);
  const [OtpDataFromModal, setOtpDataFromModal] = useState([]);
  const [isUpdateButtonActive, setIsUpdateButtonActive] = useState(false);
  const [passwordChangeConfirmationMsg, setPasswordChangeConfirmationMsg] = useState("");
  const [changePassLogout, setChangePassLogout] = useState(false);

  const [showChangePassword, setShowChangePassword] = useState(false);

  // Registration Finalize states
  const [ott, setOtt] = useState('');
  const [email, setEmail] = useState('');

  const location = useLocation();
  const navigate = useNavigate();

  // Get OTT from URL on first render
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ottFromUrl = params.get('ott');
    if (ottFromUrl) {
      setOtt(ottFromUrl);
      const url = new URL(window.location);
      url.searchParams.delete('ott');
      window.history.replaceState({}, document.title, url.pathname + url.search);
    }
  }, [location.search]);

  useEffect(() => {
    if (ott) {
      fetch(`${RESET_PASSWORDT_OTT}/${ott}`, { credentials: 'include' })
        .then(res => {
          if (res.status === 200) {
            return res.json();
          } else {
            throw new Error('Invalid or expired OTT.');
          }
        })
        .then(data => {
          // Show UI as normal (no error)
          if (data && data.email) {
            setEmail(data.email);
            setShowChangePassword(true);
          }
        })
        .catch((err) => {
          setShowChangePassword(false);
          toast.error(err.message || "Failed registration/ott", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 8000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
        });
    }
  }, [ott]);

  const handleOtp = (OtpDataToProject) => {
    setOtpDataFromModal(OtpDataToProject);
  };

  // OTP verification for registration finalize
  async function verifyOtp(OtpDataFromModal) {
    if (OtpDataFromModal.length !== 0 && ott) {
      const otp = OtpDataFromModal.join('');
      try {
        const response = await axios.post(
          `${RESET_PASSWORDT_FIN}/${ott}`,
          { email, password, otp },
          {
            headers: {
              'Content-Type': 'application/json; charset=utf-8'
            },
            withCredentials: true
          }
        );
        if (response && response.status === 200) {
          setPasswordChangeConfirmationMsg("Registration completed successfully");
          setIsUpdateButtonActive(false);
          setModalShow(true);
          setOtpModalOpen(false);
        }
      } catch (error) {
        setOtpModalOpen(false);
        toast.error(
          (error.response?.data?.message || "OTP verification failed, please try again."),
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 8000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          }
        );
        // Do NOT auto-retry. User can click "Resend OTP" in the modal if needed.
      }
    }
  }

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        animation={false}
        backdrop='static'
        keyboard={false}
        dialogClassName='my-modal'
      >
        <Modal.Header className='modal-header'>
          <Modal.Title id="contained-modal-title-vcenter">
            Registration Complete
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modal-body'>
          <p>
            Registration completed successfully, you will be redirected to the login page.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="ui button comm-button-style primary"
            onClick={() => {
              setModalShow(false);
              navigate('/');
            }}
          >
            OK
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  async function handleSubmit(isRetry = false) {
    setIsUpdateButtonActive(true);

    if (ott) {
      // Use a custom axios instance without interceptors for the registration-fin call
      const customAxios = axios.create(); // No interceptors
      try {
        const response = await customAxios.post(
          `${RESET_PASSWORDT_FIN}/${ott}`,
          { email, password },
          {
            headers: {
              'Content-Type': 'application/json; charset=utf-8'
            },
            withCredentials: true
          }
        );
        // If we get here, registration is complete (no OTP required)
        setPasswordChangeConfirmationMsg("Registration completed successfully");
        setIsUpdateButtonActive(false);
        setModalShow(true);
      } catch (error) {
        if (error.response && error.response.status === 409) {
          // OTP required, open OTP modal
          setOtpModalOpen(true);
        } else if (error.response && error.response.status === 401) {
          // Handle 401 here instead of interceptor
          toast.error("The (OTT) is not valid or has expired.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 8000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
        } else {
          toast.error(error.response?.data?.message || "Registration failed", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 8000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
        }
        setIsUpdateButtonActive(false);
      }
    }
  }

  // Called when user clicks "Resend OTP" in the OTP modal after timer expires
  const resendOtp = async () => {
    // Re-trigger the first registration-fin call to get a new OTP
    handleSubmit(true);
  };




  return (
    <>
      {showChangePassword ? (
        <div className="setresetpassword-page-bg">
          <div className="setresetpassword-header">
            <h1>CHANGE PASSWORD</h1>
          </div>
          <div className="setresetpassword-main-content">
            <section className={`setresetpassword-wrap${password.length === 0 ? ' compact' : ''}`}>
              <div className="setresetpassword-left-sec">
                <img src={changepass2} alt="Change password" title="Change Password" />
                {password.length !== 0 && (
                  <div className="setresetpassword-password-checklist">
                    <ul>
                      <PasswordChecklist
                        rules={[
                          "capital",
                          "match",
                          "specialChar",
                          "minLength",
                          "lowercase",
                          "number",
                        ]}
                        iconSize={15}
                        minLength={8}
                        value={password}
                        valueAgain={repeatPassword}
                        messages={{
                          minLength: "The minimum length of the password should be 8.",
                          specialChar: "The password should contain at least one special character.",
                          number: "The password should contain at least one numeric letter.",
                          capital: "The password should contain at least one uppercase letter.",
                          match: "Password and repeat password should match.",
                          lowercase: "The password should contain at least one lowercase letter.",
                        }}
                      />
                    </ul>
                  </div>
                )}
              </div>
              <ul className="setresetpassword-pass-elements">
                <li>
                  <div className="custom-input-wrapp">
                    <FloatingLabel
                      controlId="emailInput"
                      label="Email"
                      className="inputText"
                    >
                      <Form.Control type="text" value={email} readOnly placeholder=" " />
                    </FloatingLabel>
                  </div>
                </li>
                <li>
                  <div className="custom-input-wrapp">
                    <FloatingLabel
                      controlId="passwordInput"
                      label="Enter new password"
                      className="inputText"
                      autoComplete="off"
                      onChange={(event) => setPassword(event.target.value)}
                    >
                      <Form.Control type="password" placeholder=" " />
                      <span className="required-field-op">(Required)</span>
                      <span className="form-error error-message-show" style={{ visibility: 'hidden' }}>Password is required.</span>
                    </FloatingLabel>
                  </div>
                </li>
                <li>
                  <div className="custom-input-wrapp">
                    {password.length !== 0 ? (
                      <FloatingLabel
                        controlId="repeatPasswordInput"
                        label="Repeat password"
                        className="inputText"
                        autoComplete="off"
                        onChange={(event) => setRepeatPassword(event.target.value)}
                      >
                        <Form.Control type="password" placeholder=" " />
                        <span className="required-field-op">(Required)</span>
                        <span className="form-error error-message-show" style={{ visibility: 'hidden' }}>Repeat password is required.</span>
                      </FloatingLabel>
                    ) : null}
                  </div>
                </li>
                <li>
                  <div className="apim-pop-button-w comm-button-wrap">
                    <button
                      className="ui button comm-button-style primary apim-reset-pass-btn"
                      id="updateBtn"
                      onClick={() => handleSubmit(false)}
                      disabled={isUpdateButtonActive}
                    >
                      Update
                    </button>
                    <button
                      className="ui button comm-button-style secondary custom-loader"
                      id="loadingBtn"
                      style={{ display: 'none' }}
                    >
                      <i className="icon-plus iconLoader" />
                      Changing Password..
                    </button>
                    <button
                      className="ui button comm-button-style secondary apim-pop-button-cancel"
                      id="cancelBtn"
                      // Add cancel logic if needed
                    >
                      Cancel
                    </button>
                  </div>
                </li>
              </ul>
            </section>
            {/* ✅ Using global ToastContainer from App.js - removed local instance */}
            <MyVerticallyCenteredModal
              show={modalShow}
              onHide={() => setModalShow(false)}
            />
            {OtpModalOpen && (
              <OtpInputModal
                ModalHeading={""}
                setOpenOtpModal={setOtpModalOpen}
                handleOtp={handleOtp}
                value={OtpDataFromModal}
                verifyOtp={verifyOtp}
                credentialRecord={""}
                otpInputModelOpenendForAction={"registrationFin"}
                resendOtp={resendOtp}
              />
            )}
          </div>
          <Outlet />
        </div>
      ) : (
        <div style={{ textAlign: 'center', marginTop: '50px', color: 'red' }}>
          Something went wrong. Please check your link or try again later.
        </div>
      )}
    </>
  );
};

export default SetResetPassword;





